<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="资源账号">
              <el-input clearable v-model.trim="where.username" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns"
        :selection.sync="selection" :page-size="20"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:finance:add')">添加</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:finance:dall')">删除</el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData"
            v-if="permission.includes('sys:finance:edit')">初始化</el-button>
        </template>

        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:finance:edit')">编辑</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此资源吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:finance:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
          <el-popconfirm class="ele-action" title="确定要重置密码吗？" @confirm="resetPwd(row)"
            v-if="permission.includes('sys:finance:edit')">
            <el-button size="small" type="success" class="ele-btn-icon" slot="reference">重置</el-button>
          </el-popconfirm>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"
            v-if="permission.includes('sys:finance:status')" />
        </template>
      </ele-pro-table>
    </el-card>

    <finance-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FinanceEdit from './finance-edit';

export default {
  name: 'SystemFinance',
  components: { FinanceEdit },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/finance/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 70, align: 'center', fixed: 'left' },
        { prop: 'username', label: '资源账号', showOverflowTooltip: true, minWidth: 140, align: 'center' },
        {
          prop: 'create_user_name', label: '创建人', showOverflowTooltip: true, minWidth: 120, align: 'center',
          formatter: (row, column, cellValue) => cellValue
        },
        { prop: 'sj_amount', label: '资源余额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'status', label: '资源状态', align: 'center', width: 100, resizable: false, slot: 'status' },
        {
          prop: 'create_time', label: '创建时间', showOverflowTooltip: true, minWidth: 150, align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          prop: 'update_time', label: '更新时间', showOverflowTooltip: true, minWidth: 150, align: 'center',
          formatter: (row, column, cellValue) => (cellValue ? this.$util.toDateString(cellValue) : '')
        },
        { columnKey: 'action', label: '操作', width: 220, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false
    };
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      this.post('/finance/delete', { id: row.id }, true);
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的资源吗?', '提示', { type: 'warning' }).then(() => {
        this.post('/finance/delete', { id: this.selection.map((d) => d.id) }, true);
      }).catch(() => {});
    },
    initData() {
      this.$confirm('初始化将清空全部资源账号且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.post('/finance/initData', {}, true, () => {
          this.selection = [];
        });
      }).catch(() => {});
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/finance/status', {
        id: row.id,
        status: row.status
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = row.status === 1 ? 2 : 1;
        this.$message.error(e.message);
      });
    },
    resetPwd(row) {
      this.post('/finance/resetPwd', { id: row.id }, false);
    },
    post(url, data, reload, onSuccess) {
      const loading = this.$loading({ lock: true });
      this.$http.post(url, data).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          if (typeof onSuccess === 'function') {
            onSuccess();
          }
          if (reload) {
            this.reload();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    }
  }
};
</script>
